export const UNASSIGNED_STATUS = 1
export const SUGGESTED_STATUS = 2
export const PENDING_STATUS = 3
export const APPROVED_STATUS = 4
export const CANCELLED_STATUS = 5
export const NEW_STATUS = 6
